import React, { useState } from 'react';
import '../css/EmailTable.css';

const EmailRead = () => {
    const [activeTab, setActiveTab] = useState('Unread To');

    const emails = {
        'Unread To': [
            { id: 'LTGEN-EMAIL-013514', subject: 'MCC_531_MVPS-45 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013515', subject: 'MCC_531_MVPS-44 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013514', subject: 'MCC_531_MVPS-45 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013515', subject: 'MCC_531_MVPS-44 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013514', subject: 'MCC_531_MVPS-45 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013515', subject: 'MCC_531_MVPS-44 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013514', subject: 'MCC_531_MVPS-45 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013515', subject: 'MCC_531_MVPS-44 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013514', subject: 'MCC_531_MVPS-45 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013515', subject: 'MCC_531_MVPS-44 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013514', subject: 'MCC_531_MVPS-45 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013515', subject: 'MCC_531_MVPS-44 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
            { id: 'LTGEN-EMAIL-013516', subject: 'MCC_531_MVPS-43 - ARCS Installation ...', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
        ],
        'Unread CC': [
            { id: 'LTGEN-EMAIL-013554', subject: 'PM210012-LTG510-WIR-ELE-00352', sender: 'LARSEN & TOUBRO', date: '21/12/24' },
            { id: 'LTGEN-EMAIL-013553', subject: 'PM210012-LTG510-WIR-CIV-01904', sender: 'LARSEN & TOUBRO', date: '19/12/24' },
        ],
    };

    return (
        <div className="email-table">
            <div className="email-header">
                <div>Mail</div>
                <h6 className="counter">562</h6>
            </div>

            
            <div className="email-list">
                {emails[activeTab].map((email) => (
                    <div key={email.id} className="email-item">
                        <div className="email-id">{email.id}</div>
                        <div className="email-subject">{email.subject}</div>
                        <div className="email-sender">{email.sender}</div>
                        <div className="email-date">{email.date}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EmailRead;
